// public basemap tile templates (also the keys of the offline tile cache)
export const LAYERS = {
  hybrid: ['https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', 21],
  road: ['https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', 21],
  sat: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', 20],
  osm: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png', 19],
  topo: ['https://a.tile.opentopomap.org/{z}/{x}/{y}.png', 17],
};
export const LAYERS_URLS = Object.values(LAYERS).map(([u]) => u);
